/* unplugin-vue-components disabled */import { render } from "./teacherAndCourse.vue?vue&type=template&id=49bea058&scoped=true"
import script from "./teacherAndCourse.vue?vue&type=script&lang=js"
export * from "./teacherAndCourse.vue?vue&type=script&lang=js"

import "./teacherAndCourse.vue?vue&type=style&index=0&id=49bea058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bea058"]])

export default __exports__